import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=APPLE_FREE_TRIAL_FEATURE_EXP_2:control
// ?preferred_variant=APPLE_FREE_TRIAL_FEATURE_EXP_2:variant_1

export const AppleFreeTrialExpName2 = 'APPLE_FREE_TRIAL_FEATURE_EXP_2' as const;

export type AppleFreeTrialExp2Variants = ToVariants<typeof AppleFreeTrialExp2Variants>;

export const AppleFreeTrialExp2Variants = {
	CONTROL: 'control',
	/**  Free Trial Feature in “best price” section (as well as other buybox filters) + adjusted wording.  */
	VARIANT_1: 'variant_1',
} as const;

export default generate(AppleFreeTrialExpName2, AppleFreeTrialExp2Variants);
